import { Form, Row, Radio } from 'antd'
import { FormInstance } from 'antd/lib/form'
import { filteDisabled, filteHidden } from '../ControlformState/useFormState'
import { useTypedSelector } from '../../redux/store'

interface Props {
  form: FormInstance
  required?: boolean // 校验
  onFieldsChange: () => void
}
// 主图
const Mainpic = (props: Props) => {
  const { form, required, onFieldsChange } = props
  const { FormState } = useTypedSelector((state) => state.ControlformState)
  const { matchDisabled } = useTypedSelector((state) => state.goodsReducer)

  const formItemLayout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  }
  const itemLayou = {
    style: {
      width: '100%',
      marginBottom: '10px',
    },
  }
  return (
    <Form
      {...formItemLayout}
      // name='mainpic'
      form={form}
      onFieldsChange={onFieldsChange}
      labelAlign="right"
      colon={false}
      style={{ margin: '10px 0 0 0', padding: '0 10px 0 0' }}
      size="small"
    >
      <Row>
        <Form.Item
          label="关系"
          name="picMatch"
          rules={[{ required: required, message: '请选择图片关系' }]}
          {...itemLayou}
          initialValue={'1'}
          hidden
        >
          <Radio.Group
            style={{
              display: filteHidden('picMatch', FormState) ? 'none' : 'block',
            }}
            disabled={filteDisabled('picMatch', FormState)}
          >
            {/* // 图片匹配度 */}
            <Radio value={'1'} disabled={matchDisabled}>
              匹配
            </Radio>
            <Radio value={'2'}>类似</Radio>
          </Radio.Group>
        </Form.Item>
      </Row>
    </Form>
  )
}

export default Mainpic
import { Form, Row, Radio } from 'antd'
import { FormInstance } from 'antd/lib/form'
import { filteDisabled, filteHidden } from '../ControlformState/useFormState'
import { useTypedSelector } from '../../redux/store'

interface Props {
  form: FormInstance
  required?: boolean // 校验
  onFieldsChange: () => void
}
// 主图
const Mainpic = (props: Props) => {
  const { form, required, onFieldsChange } = props
  const { FormState } = useTypedSelector((state) => state.ControlformState)
  const { matchDisabled } = useTypedSelector((state) => state.goodsReducer)

  const formItemLayout = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  }
  const itemLayou = {
    style: {
      width: '100%',
      marginBottom: '10px',
    },
  }
  return (
    <Form
      {...formItemLayout}
      // name='mainpic'
      form={form}
      onFieldsChange={onFieldsChange}
      labelAlign="right"
      colon={false}
      style={{ margin: '10px 0 0 0', padding: '0 10px 0 0' }}
      size="small"
    >
      <Row>
        <Form.Item
          label="关系"
          name="picMatch"
          rules={[{ required: required, message: '请选择图片关系' }]}
          {...itemLayou}
          initialValue={'1'}
          hidden
        >
          <Radio.Group
            style={{
              display: filteHidden('picMatch', FormState) ? 'none' : 'block',
            }}
            disabled={filteDisabled('picMatch', FormState)}
          >
            {/* // 图片匹配度 */}
            <Radio value={'1'} disabled={matchDisabled}>
              匹配
            </Radio>
            <Radio value={'2'}>类似</Radio>
          </Radio.Group>
        </Form.Item>
      </Row>
    </Form>
  )
}

export default Mainpic
